export function getPeriodoEvaluado(evaluaciones: Record<string, string | null>): string {
    const years = Object.keys(evaluaciones)
        .map((y) => parseInt(y))
        .filter((y) => !isNaN(y))
        .sort((a, b) => a - b);

    if (years.length === 0) return 'sin datos';

    const first = years[0];
    const last = years[years.length - 1];

    return `desde ${first} hasta ${last}`;
}